import {
  EXTRATO_CONTA_REQUEST,
  EXTRATO_CONTA_SUCCESS,
  LIMPA_EXTRATO,
} from './constants';

export function getExtratoContaRequest(anomes) {
  return {
    type: EXTRATO_CONTA_REQUEST,
    anomes,
  };
}

export function getExtratoContaSuccess(values) {
  return {
    type: EXTRATO_CONTA_SUCCESS,
    values,
  };
}

export function limpaExtrato() {
  return {
    type: LIMPA_EXTRATO,
  };
}
